import React from "react";

const NewStaffType = ({ onSubmit, onCancel }) => {
	const nameRef = React.createRef();
	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				const { value } = nameRef.current;
				if (value) {
					onSubmit(value);
					nameRef.current.value = "";
				}
			}}
		>
			<div className="form-row">
				<div className="col-md-8">
					<input
						ref={nameRef}
						type="text"
						required
						placeholder="Enter Staff type"
						className="form-control input-height"
					/>
				</div>

				{/* Save button */}
				<div className="col">
					<button
						type="submit"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
					>
						Save
						<i className="material-icons">arrow_right_alt</i>
					</button>
				</div>

				{/* Cancel button */}
				<div className="col">
					<button
						onClick={onCancel}
						type="button"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-default"
					>
						<i className="material-icons text-danger">cancel</i>
						Cancel
					</button>
				</div>
			</div>
		</form>
	);
};

export default NewStaffType;
